import React, { useState } from "react";
import Image from "next/image";
import { Grid } from "@mui/material";
import RequestSampleModalBtn from "../Modal/RequestSample";
import Slider from "react-slick";
import AbsoluteSkewebar from "../Common/AbsoluteSkewebar";
import ContactUsModalBtn from "../Modal/ContactUs";

const Expertise = ({ Options }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const sliderData = [
    {
      id: 0,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709101409.svg",
      title: "Customised formulations",
      description:
        "We understand that one size does not fit all in the world of chemicals. That's why we excel at crafting bespoke chemical formulations that align perfectly with your specific requirements. Our team of skilled chemists and engineers collaborates closely with you to design and adapt formulas that achieve the precise properties and performance characteristics you demand.",
    },
    {
      id: 1,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709101476.svg",
      title: "Quality Assurance",
      description:
        "Quality is our cornerstone. We've built a reputation for unwavering commitment to the highest standards of quality and safety. Our stringent quality control processes and state-of-the-art testing facilities ensure that every batch we produce meets or exceeds the strictest industry and regulatory benchmarks ",
    },
    {
      id: 2,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709101520.svg",
      title: "Process expertise",
      description:
        "Our team brings deep technical expertise and experience to the table. We've honed our processes to perfection, optimising for efficiency, yield, and quality. From scaling production to troubleshooting complex issues, our process experts ensure that your chemical manufacturing journey is smooth, efficient, and cost-effective",
    },
    {
      id: 3,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709101562.svg",
      title: "Cost competitiveness",
      description:
        "Our advanced technology-driven processes and supply chain management allow us to find cost efficiencies without compromising quality. With Elchemy, you get the best of both worlds – custom-tailored solutions at competitive prices.",
    },
    {
      id: 4,
      image:
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709101599.svg",
      title: "Technical support",
      description:
        "Your project's success is our priority, and we don't stop at delivering your chemical solutions. Our dedicated technical support team is here to assist you every step of the way. Whether you encounter challenges in production, need guidance on optimizing your formulations, or require troubleshooting expertise, we're just a call or message away.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    pauseOnHover: true,
    fadeout: true,
    autoplay: false,
    vertical: true,
    beforeChange: (current, next) => setActiveSlide(next),
    // dotsClass: "slick-dots custom-slick-dots",
    appendDots: (dots) => (
      <div className="">
        <ul>{dots}</ul>
      </div>
    ),
    customPaging: function (i) {
      return (
        <a>
          <div className="custom-dots">
            <div
              className={`dot-container ${activeSlide === i ? "active" : ""}`}
            >
              <div className={activeSlide === i ? "outer-circle" : ""}>
                <div
                  className="inner-dot"
                  style={{
                    background: activeSlide === i ? "#EF4136" : "#B3B3B3",
                  }}
                />
              </div>
            </div>
          </div>
        </a>
      );
    },
  };

  return (
    <div className="">
      <div className=" pt-10 md:pt-24">
        <div className="flex  text-3xl ">
          <AbsoluteSkewebar
            text={"Why Elchemy Is A Trusted Contract Manufacturer"}
          />
        </div>
      </div>
      <div className="flex md:flex-row  justify-between pb-20 items-center md:gap-2 mt-6 md:mt-16">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-10">
          <div className="lg:w-[50%] w-full ">
            <div className=" fastFadeOut" key={activeSlide}>
              <p className="text-[1.4rem] md:text-[1.9rem] font-mukta">
                {sliderData[activeSlide]?.title}
              </p>
              <p className="mt-2 md:mt-6 md:w-full text-[#666666] text-[16px] font-normal ">
                {sliderData[activeSlide]?.description}
              </p>
            </div>

            <div className="w-full flex justify-around md:justify-start ">
              <ContactUsModalBtn
                heading={"Request Custom Formulation"}
                service="2"
                subHeading={"Fill in the details required to get the sample."}
                classes={
                  "w-[240px] h-[48px] bg-red mt-6 md:mt-12 text-[#fff] rounded-[3px]"
                }
              >
                <div className="">Request Custom Formulation</div>
              </ContactUsModalBtn>
            </div>
          </div>
          <div className="lg:w-[50%] w-full">
            <div className=" cursor-pointer lg:h-[18rem]  w-full fastFadeOut ">
              <Slider {...settings}>
                {sliderData?.map((item, index) => (
                  <div key={index}>
                    <img
                      src={item.image}
                      alt={`Slide ${index}`}
                      className="h-[14rem]  md:h-[18rem] w-full object-cover"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-20"></div>
    </div>
  );
};

export default Expertise;
